import { MoveBpaCsvSection } from "./MoveBpaCsvSection.js";

export function MoveBpaTab() {
  return <MoveBpaCsvSection />;
}
